import { render, staticRenderFns } from "./UserProfileContent.vue?vue&type=template&id=017b6927&"
import script from "./UserProfileContent.vue?vue&type=script&lang=js&"
export * from "./UserProfileContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports